import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDrafts = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M126.466 34.1767C126.466 33.002 125.996 31.8826 125.167 31.0534L95.4261 1.29908C94.5969 0.469878 93.4637 0 92.289 0H33.5957C31.1495 0 29.1733 1.97625 29.1733 4.42238V119.404C29.1733 121.85 31.1495 123.827 33.5957 123.827H122.043C124.489 123.827 126.466 121.85 126.466 119.404V34.1767ZM90.2574 10.1991L116.267 36.2083H90.2574V10.1991ZM21.0866 127.365V16.1733H17.4224C14.9763 16.1733 13 18.1495 13 20.5957V135.578C13 138.024 14.9763 140 17.4224 140H105.87C108.316 140 110.292 138.024 110.292 135.578V131.913H25.13C22.9065 131.913 21.4656 130.348 21.1514 128.251C21.1088 128.004 21.0866 127.75 21.0866 127.491V127.365Z",
		fill: "#26292E"
	})
});
export default SvgDrafts;
